import React from 'react';

export const Delimeter: React.FC = () => {
  return (
    <div className="field-list">
      <div className="data-name">
        <p>&nbsp;</p>
      </div>
    </div>
  );
};